module.exports = __webpack_public_path__ + "img/greyCross.d873fcbd.svg";